"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialEngineSingleton = void 0;
var MaterialData_1 = require("./implementation/data/MaterialData");
var materialDatabase_1 = require("./implementation/materialDatabase");
var THREE = __importStar(require("../../../externals/three"));
var MaterialPropertiesStandard_1 = require("../../../shared/materials/MaterialPropertiesStandard");
var GlobalUtilsThreeJs_1 = __importDefault(require("../../../shared/util/GlobalUtilsThreeJs"));
var TextureLoader_1 = __importDefault(require("../TextureLoader"));
var MaterialEngine = /** @class */ (function () {
    // #region Properties (3)
    // #endregion Properties (3)
    // #region Constructors (1)
    function MaterialEngine() {
    }
    // #endregion Constructors (1)
    // #region Public Methods (1)
    /**
       * Load the material content into a scene graph node.
       *
       * @param content the material content
       * @returns the scene graph node
       */
    MaterialEngine.prototype.loadContent = function (content) {
        return __awaiter(this, void 0, void 0, function () {
            var material, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!content)
                            throw new Error('MaterialEngine.loadContent: Invalid content was provided to material engine.');
                        material = new MaterialPropertiesStandard_1.MaterialPropertiesStandard();
                        if (!content.data) return [3 /*break*/, 11];
                        data = content.data;
                        if (!data.materialpreset) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadPresetMaterial(data.materialpreset, material)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(data.materialType && data.materialType !== 'standard')) return [3 /*break*/, 3];
                        return [3 /*break*/, 10];
                    case 3:
                        if (!data.version) return [3 /*break*/, 10];
                        if (!(data.version === '1.0')) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.loadMaterialV1(data, material)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 10];
                    case 5:
                        if (!(data.version === '2.0')) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.loadMaterialV2(data, material)];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 10];
                    case 7:
                        if (!(data.version === '3.0')) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.loadMaterialV3(data, material)];
                    case 8:
                        _a.sent();
                        return [3 /*break*/, 10];
                    case 9: throw new Error('MaterialEngine.loadContent: Material data version not supported.');
                    case 10: return [3 /*break*/, 12];
                    case 11: throw new Error('MaterialEngine.loadContent: No material data was provided to material engine.');
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    // #endregion Public Methods (1)
    // #region Private Methods (9)
    MaterialEngine.prototype.assignGeneralDefinition = function (id, generalDefinition, specificDefinition, material) {
        return __awaiter(this, void 0, void 0, function () {
            var map, map, map, map, map, map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(generalDefinition.transparencytexture && !specificDefinition.transparencytexture)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadMap(generalDefinition.transparencytexture, id.class)];
                    case 1:
                        map = _a.sent();
                        if (map)
                            material.alphaMap = map;
                        _a.label = 2;
                    case 2:
                        if (!(generalDefinition.bumptexture && !specificDefinition.bumptexture)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.loadMap(generalDefinition.bumptexture, id.class)];
                    case 3:
                        map = _a.sent();
                        if (map)
                            material.bumpMap = map;
                        _a.label = 4;
                    case 4:
                        if (generalDefinition.hasOwnProperty('bumpAmplitude') && !specificDefinition.hasOwnProperty('bumpAmplitude'))
                            material.bumpScale = generalDefinition.bumpAmplitude;
                        if (generalDefinition.color && !specificDefinition.color)
                            material.color = new THREE.Color(GlobalUtilsThreeJs_1.default.toTinyColor(generalDefinition.color).toRgbString());
                        if (!(generalDefinition.bitmaptexture && !specificDefinition.bitmaptexture)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.loadMap(generalDefinition.bitmaptexture, id.class)];
                    case 5:
                        map = _a.sent();
                        if (map)
                            material.map = map;
                        _a.label = 6;
                    case 6:
                        if (generalDefinition.hasOwnProperty('metalness') && !specificDefinition.hasOwnProperty('metalness'))
                            material.metalness = generalDefinition.metalness;
                        if (!(generalDefinition.metalnesstexture && !specificDefinition.metalnesstexture)) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.loadMap(generalDefinition.metalnesstexture, id.class)];
                    case 7:
                        map = _a.sent();
                        if (map)
                            material.metalnessMap = map;
                        _a.label = 8;
                    case 8:
                        if (!(generalDefinition.normaltexture && !specificDefinition.normaltexture)) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.loadMap(generalDefinition.normaltexture, id.class)];
                    case 9:
                        map = _a.sent();
                        if (map)
                            material.normalMap = map;
                        _a.label = 10;
                    case 10:
                        if (generalDefinition.hasOwnProperty('transparency') && !specificDefinition.hasOwnProperty('transparency'))
                            material.opacity = 1 - generalDefinition.transparency;
                        if (generalDefinition.hasOwnProperty('roughness') && !specificDefinition.hasOwnProperty('roughness'))
                            material.roughness = generalDefinition.roughness;
                        if (!(generalDefinition.roughnesstexture && !specificDefinition.roughnesstexture)) return [3 /*break*/, 12];
                        return [4 /*yield*/, this.loadMap(generalDefinition.roughnesstexture, id.class)];
                    case 11:
                        map = _a.sent();
                        if (map)
                            material.roughnessMap = map;
                        _a.label = 12;
                    case 12:
                        if (generalDefinition.side && !specificDefinition.side)
                            material.side = generalDefinition.side === 'front' ? MaterialData_1.MATERIAL_SIDE.FRONT : generalDefinition.side === 'back' ? MaterialData_1.MATERIAL_SIDE.BACK : MaterialData_1.MATERIAL_SIDE.DOUBLE;
                        return [2 /*return*/];
                }
            });
        });
    };
    MaterialEngine.prototype.assignSpecificDefinition = function (id, specificDefinition, material) {
        return __awaiter(this, void 0, void 0, function () {
            var map, map, map, map, map, map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!specificDefinition.transparencytexture) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadMap(specificDefinition.transparencytexture, id.class + '/' + id.specific)];
                    case 1:
                        map = _a.sent();
                        if (map)
                            material.alphaMap = map;
                        _a.label = 2;
                    case 2:
                        if (!specificDefinition.bumptexture) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.loadMap(specificDefinition.bumptexture, id.class + '/' + id.specific)];
                    case 3:
                        map = _a.sent();
                        if (map)
                            material.bumpMap = map;
                        _a.label = 4;
                    case 4:
                        if (specificDefinition.hasOwnProperty('bumpAmplitude'))
                            material.bumpScale = specificDefinition.bumpAmplitude;
                        if (specificDefinition.color)
                            material.color = new THREE.Color(GlobalUtilsThreeJs_1.default.toTinyColor(specificDefinition.color).toRgbString());
                        if (!specificDefinition.bitmaptexture) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.loadMap(specificDefinition.bitmaptexture, id.class + '/' + id.specific)];
                    case 5:
                        map = _a.sent();
                        if (map)
                            material.map = map;
                        _a.label = 6;
                    case 6:
                        if (specificDefinition.hasOwnProperty('metalness'))
                            material.metalness = specificDefinition.metalness;
                        if (!specificDefinition.metalnesstexture) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.loadMap(specificDefinition.metalnesstexture, id.class + '/' + id.specific)];
                    case 7:
                        map = _a.sent();
                        if (map)
                            material.metalnessMap = map;
                        _a.label = 8;
                    case 8:
                        if (!specificDefinition.normaltexture) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.loadMap(specificDefinition.normaltexture, id.class + '/' + id.specific)];
                    case 9:
                        map = _a.sent();
                        if (map)
                            material.normalMap = map;
                        _a.label = 10;
                    case 10:
                        if (specificDefinition.hasOwnProperty('transparency'))
                            material.opacity = 1 - specificDefinition.transparency;
                        if (specificDefinition.hasOwnProperty('roughness'))
                            material.roughness = specificDefinition.roughness;
                        if (!specificDefinition.roughnesstexture) return [3 /*break*/, 12];
                        return [4 /*yield*/, this.loadMap(specificDefinition.roughnesstexture, id.class + '/' + id.specific)];
                    case 11:
                        map = _a.sent();
                        if (map)
                            material.roughnessMap = map;
                        _a.label = 12;
                    case 12:
                        if (specificDefinition.side)
                            material.side = specificDefinition.side === 'front' ? MaterialData_1.MATERIAL_SIDE.FRONT : specificDefinition.side === 'back' ? MaterialData_1.MATERIAL_SIDE.BACK : MaterialData_1.MATERIAL_SIDE.DOUBLE;
                        return [2 /*return*/];
                }
            });
        });
    };
    MaterialEngine.prototype.getClassAndSpecificID = function (id) {
        // for a while, we had documented the presets to be 10, 20, 30 and 40 here, we allow for the few cases where this was used to succeed
        if (id < 100 && id % 10 == 0)
            id /= 10;
        // if the id is less than 10, multiply it by 100
        if (id < 10)
            id *= 100;
        var cast = function (id) {
            var idString = String(id);
            return idString.padStart(2, '0').slice(0, 2);
        };
        return {
            class: cast(Math.floor(id / 100)),
            specific: cast(id - (Math.floor(id / 100) * 100))
        };
    };
    MaterialEngine.prototype.loadMap = function (url, id) {
        return __awaiter(this, void 0, void 0, function () {
            var image;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!id) return [3 /*break*/, 2];
                        return [4 /*yield*/, TextureLoader_1.default.loadTexture(url)];
                    case 1:
                        image = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, TextureLoader_1.default.loadTexture('https://viewer.shapediver.com/v2/materials/1024/' + id + '/' + url)];
                    case 3:
                        image = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, image];
                }
            });
        });
    };
    MaterialEngine.prototype.loadMapWithProperties = function (texture) {
        return __awaiter(this, void 0, void 0, function () {
            var image;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, TextureLoader_1.default.loadTexture(texture.href)];
                    case 1:
                        image = _a.sent();
                        image.wrapS = texture.wrapS === 1 ? THREE.ClampToEdgeWrapping : texture.wrapS === 2 ? THREE.MirroredRepeatWrapping : THREE.RepeatWrapping;
                        image.wrapT = texture.wrapT === 1 ? THREE.ClampToEdgeWrapping : texture.wrapT === 2 ? THREE.MirroredRepeatWrapping : THREE.RepeatWrapping;
                        image.center = texture.center ? new THREE.Vector2(texture.center[0], texture.center[1]) : new THREE.Vector2();
                        image.color = texture.color ? new THREE.Vector4(texture.color[0] / 255, texture.color[1] / 255, texture.color[2] / 255, texture.color[3] / 255) : new THREE.Vector4(1, 1, 1, 1);
                        image.offset = texture.offset ? new THREE.Vector2(texture.offset[0], texture.offset[1]) : new THREE.Vector2();
                        image.repeat = texture.repeat ? new THREE.Vector2(texture.repeat[0], texture.repeat[1]) : new THREE.Vector2(1, 1);
                        return [2 /*return*/, image];
                }
            });
        });
    };
    MaterialEngine.prototype.loadMaterialV1 = function (data, material) {
        return __awaiter(this, void 0, void 0, function () {
            var map, map, map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // ambient is ignored
                        if (data.color) {
                            material.color = new THREE.Color(GlobalUtilsThreeJs_1.default.toTinyColor(data.color).toRgbString());
                        }
                        else if (data.diffuse) {
                            material.color = new THREE.Color(GlobalUtilsThreeJs_1.default.toTinyColor(data.diffuse).toRgbString());
                        }
                        // Note: Not possible in Viewer 2 at the moment
                        // if(data.emission)
                        //     material.emissiveness = this._converter.toColor(data.emission);
                        // specular is ignored
                        if (data.shine || data.shine === 0) {
                            material.metalness = Math.min(1, data.shine);
                            material.roughness = 1 - (Math.min(1, data.shine));
                        }
                        if (data.hasOwnProperty('transparency'))
                            material.opacity = 1 - data.transparency;
                        if (!data.bitmaptexture) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadMap(data.bitmaptexture)];
                    case 1:
                        map = _a.sent();
                        if (map)
                            material.map = map;
                        _a.label = 2;
                    case 2:
                        if (!data.bumptexture) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.loadMap(data.bumptexture)];
                    case 3:
                        map = _a.sent();
                        if (map)
                            material.bumpMap = map;
                        _a.label = 4;
                    case 4:
                        if (!data.transparencytexture) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.loadMap(data.transparencytexture)];
                    case 5:
                        map = _a.sent();
                        if (map)
                            material.alphaMap = map;
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    MaterialEngine.prototype.loadMaterialV2 = function (data, material) {
        return __awaiter(this, void 0, void 0, function () {
            var map, map, map, map, map, map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // ambient is ignored
                        if (data.color)
                            material.color = new THREE.Color(GlobalUtilsThreeJs_1.default.toTinyColor(data.color).toRgbString());
                        material.side = data.side === 'front' ? MaterialData_1.MATERIAL_SIDE.FRONT : data.side === 'back' ? MaterialData_1.MATERIAL_SIDE.BACK : MaterialData_1.MATERIAL_SIDE.DOUBLE;
                        if (data.metalness || data.metalness === 0)
                            material.metalness = data.metalness;
                        if (data.roughness || data.roughness === 0)
                            material.roughness = data.roughness;
                        if (data.hasOwnProperty('transparency'))
                            material.opacity = 1 - data.transparency;
                        if (!data.bitmaptexture) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadMap(data.bitmaptexture)];
                    case 1:
                        map = _a.sent();
                        if (map)
                            material.map = map;
                        _a.label = 2;
                    case 2:
                        if (!data.metalnesstexture) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.loadMap(data.metalnesstexture)];
                    case 3:
                        map = _a.sent();
                        if (map)
                            material.metalnessMap = map;
                        _a.label = 4;
                    case 4:
                        if (!data.roughnesstexture) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.loadMap(data.roughnesstexture)];
                    case 5:
                        map = _a.sent();
                        if (map)
                            material.roughnessMap = map;
                        _a.label = 6;
                    case 6:
                        if (!data.bumptexture) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.loadMap(data.bumptexture)];
                    case 7:
                        map = _a.sent();
                        if (map)
                            material.bumpMap = map;
                        _a.label = 8;
                    case 8:
                        if (!data.normaltexture) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.loadMap(data.normaltexture)];
                    case 9:
                        map = _a.sent();
                        if (map)
                            material.normalMap = map;
                        _a.label = 10;
                    case 10:
                        if (!data.transparencytexture) return [3 /*break*/, 12];
                        return [4 /*yield*/, this.loadMap(data.transparencytexture)];
                    case 11:
                        map = _a.sent();
                        if (map)
                            material.alphaMap = map;
                        _a.label = 12;
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    MaterialEngine.prototype.loadMaterialV3 = function (data, material) {
        return __awaiter(this, void 0, void 0, function () {
            var map, map, map, map, map, map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // ambient is ignored
                        if (data.color)
                            material.color = new THREE.Color(GlobalUtilsThreeJs_1.default.toTinyColor(data.color).toRgbString());
                        material.side = data.side === 'front' ? MaterialData_1.MATERIAL_SIDE.FRONT : data.side === 'back' ? MaterialData_1.MATERIAL_SIDE.BACK : MaterialData_1.MATERIAL_SIDE.DOUBLE;
                        if (data.metalness || data.metalness === 0)
                            material.metalness = data.metalness;
                        if (data.roughness || data.roughness === 0)
                            material.roughness = data.roughness;
                        if (data.hasOwnProperty('transparency'))
                            material.opacity = 1 - data.transparency;
                        // Note: Not possible in Viewer 2 at the moment
                        // if(data.alphaThreshold || data.alphaThreshold === 0)
                        //     material.alphaCutoff = data.alphaThreshold;
                        if (data.bumpAmplitude || data.bumpAmplitude === 0)
                            material.bumpScale = data.bumpAmplitude;
                        if (!data.bitmaptexture) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadMapWithProperties(data.bitmaptexture)];
                    case 1:
                        map = _a.sent();
                        if (map)
                            material.map = map;
                        _a.label = 2;
                    case 2:
                        if (!data.metalnesstexture) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.loadMapWithProperties(data.metalnesstexture)];
                    case 3:
                        map = _a.sent();
                        if (map)
                            material.metalnessMap = map;
                        _a.label = 4;
                    case 4:
                        if (!data.roughnesstexture) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.loadMapWithProperties(data.roughnesstexture)];
                    case 5:
                        map = _a.sent();
                        if (map)
                            material.roughnessMap = map;
                        _a.label = 6;
                    case 6:
                        if (!data.bumptexture) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.loadMapWithProperties(data.bumptexture)];
                    case 7:
                        map = _a.sent();
                        if (map)
                            material.bumpMap = map;
                        _a.label = 8;
                    case 8:
                        if (!data.normaltexture) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.loadMapWithProperties(data.normaltexture)];
                    case 9:
                        map = _a.sent();
                        if (map)
                            material.normalMap = map;
                        _a.label = 10;
                    case 10:
                        if (!data.transparencytexture) return [3 /*break*/, 12];
                        return [4 /*yield*/, this.loadMapWithProperties(data.transparencytexture)];
                    case 11:
                        map = _a.sent();
                        if (map)
                            material.alphaMap = map;
                        _a.label = 12;
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    MaterialEngine.prototype.loadPresetMaterial = function (preset, material) {
        return __awaiter(this, void 0, void 0, function () {
            var idStrings;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        idStrings = this.getClassAndSpecificID(preset);
                        if (!(materialDatabase_1.materialDatabase[idStrings.class] && materialDatabase_1.materialDatabase[idStrings.class][idStrings.specific])) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.assignSpecificDefinition(idStrings, materialDatabase_1.materialDatabase[idStrings.class][idStrings.specific], material)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.assignGeneralDefinition(idStrings, materialDatabase_1.materialDatabase[idStrings.class].properties, materialDatabase_1.materialDatabase[idStrings.class][idStrings.specific], material)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 9];
                    case 3:
                        if (!materialDatabase_1.materialDatabase[idStrings.class]['00']) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.assignSpecificDefinition({ class: idStrings.class, specific: '00' }, materialDatabase_1.materialDatabase[idStrings.class]['00'], material)];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.assignGeneralDefinition({ class: idStrings.class, specific: '00' }, materialDatabase_1.materialDatabase[idStrings.class].properties, materialDatabase_1.materialDatabase[idStrings.class]['00'], material)];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 9];
                    case 6: return [4 /*yield*/, this.assignSpecificDefinition({ class: '00', specific: '00' }, materialDatabase_1.materialDatabase['00']['00'], material)];
                    case 7:
                        _a.sent();
                        return [4 /*yield*/, this.assignGeneralDefinition({ class: '00', specific: '00' }, materialDatabase_1.materialDatabase['00'].properties, materialDatabase_1.materialDatabase['00']['00'], material)];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    return MaterialEngine;
}());
exports.MaterialEngineSingleton = new MaterialEngine();
